import { BreedSize, RecipeRecommendationRulesConfig } from '../types/config';

/**
 * Resolve breed size from breed name override or weight-based ranges.
 * Priority: breed_size_overrides[raza] > breed_size_ranges by weight > fallback by weight.
 */
export function resolveBreedSize(raza: string, pesoKg: number, config: RecipeRecommendationRulesConfig): BreedSize {
  const override = config.breed_size_overrides?.[raza];
  if (override) return override;

  const ranges = config.breed_size_ranges;
  if (ranges) {
    const orderedSizes: BreedSize[] = ['toy', 'pequeno', 'mediano', 'grande', 'gigante'];
    for (const size of orderedSizes) {
      const range = ranges[size];
      if (range && pesoKg >= range.min_kg && pesoKg < range.max_kg) {
        return size;
      }
    }
  }

  // Hardcoded fallback if config ranges are missing
  if (pesoKg < 5) return 'toy';
  if (pesoKg < 10) return 'pequeno';
  if (pesoKg < 25) return 'mediano';
  if (pesoKg < 45) return 'grande';
  return 'gigante';
}
